import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import {
    BreadCrumbs,
    PageTitleWithToolTip,
    AddButton,
    CircularLoading,
    Tabs
} from "../../Common";

import EmailAlertTable from "./CustomTable/Table";
import TooltipNode from './TooltipNode'
import useEmailAlert from "./context/useEmailAlert";
import EmailAlertFormModal from "./EmailAlertFormModal";
import EmailAlertTablePlaceholder from "./EmailAlertTablePlaceholder";
import AlertsSentTable from "./AlertsSentTable";

const EmailAlerts = () => {
    const {
        onChangeModalState,
        initializeEmailAlertData,
        tableData,
        isLoading
    } = useEmailAlert();

    // AB#16929: tab 1 = email alert configuration, tab 2 = Alerts Sent report ('#2' deep link).
    const [activeTab, setActiveTab] = useState(window.location.hash === '#2' ? 2 : 1);

    useEffect(() => {
        initializeEmailAlertData();
    }, [])

    const emailAlertsTab = (
        <Grid
            key="email-alerts-tab"
            container
            direction="row"
            alignItems="center"
        >
            <Grid item align="right" sx={{ marginLeft: "auto" }}>
                <AddButton
                    text={"Create new email alert"}
                    onClick={onChangeModalState}
                    disabled={isLoading}
                />
            </Grid>
            <Grid item xs={12} mt={"30px"}>
                {
                    isLoading
                        ? (
                            <div className="tablediv">
                                <CircularLoading size={35} marginTop={1} />
                            </div>
                        ) : (
                            (tableData && tableData.length) > 0 ? <EmailAlertTable /> : <EmailAlertTablePlaceholder />
                        )
                }
            </Grid>
        </Grid>
    );

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Account Details", to: `/Account` },
                    { text: "Manage Email Alerts" },
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} md={6} lg={6}>
                    <PageTitleWithToolTip
                        pageTitle={"Manage Email Alerts"}
                        toolTipNode={<TooltipNode />}
                    />
                </Grid>
                <Grid item xs={12} mt={"15px"}>
                    <Tabs
                        activeTab={activeTab}
                        onhandleChange={(e, newValue) => setActiveTab(newValue)}
                        labels={["Email Alerts", "Alerts Sent"]}
                        tabElements={[emailAlertsTab, <AlertsSentTable key="alerts-sent-tab" />]}
                    />
                </Grid>
            </Grid>
            <EmailAlertFormModal />
        </>
    )
};

export default EmailAlerts;
